import {
  SkeletonShimmer,
  SkeletonWrapper,
} from 'components/storybook-migration/skeleton/Skeleton.styled';
import { SkeletonProps } from 'components/storybook-migration/skeleton/Skeleton.types';
import { useStore } from 'store';

export const Skeleton = ({
  width = '100%',
  height = '100%',
  borderRadius = '0.3125rem',
  ...props
}: SkeletonProps) => {
  const [appTheme] = useStore((state) => [state.appTheme]);
  return (
    <SkeletonWrapper
      $appTheme={appTheme}
      data-testid="skeleton-wrapper"
      style={{ width, height, borderRadius }}
      {...props}
    >
      <SkeletonShimmer $appTheme={appTheme} data-testid="skeleton-shimmer" />
    </SkeletonWrapper>
  );
};
